import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { useIntl } from 'react-intl';
import { Query, QueryGetAvailableInteriorColorsArgs } from 'generated/graphql';
import { interiorColors } from 'cache';
import { INTERIOR_COLORS } from 'apollo-client/queries/getAvailableInteriorColors';
import { useLocalCache } from 'hooks/useLocalCache';

import * as S from './FiltersSidebar.styles';

export const InteriorColorsFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [ongetAvailableInteriorColors, { loading, data }] = useLazyQuery<Query, QueryGetAvailableInteriorColorsArgs>(
    INTERIOR_COLORS
  );

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>
        <span test-id="InteriorColorsFilterLabel">{formatMessage({ id: 'filters.interiorColors.label' })}</span>
      </EuiFormLabel>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.interiorColors.placeholder' })}
        options={data?.getAvailableInteriorColors?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.interiorColors?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          ongetAvailableInteriorColors({ variables: { inputInteriorColor: e } });
        }}
        onClick={(): void => {
          ongetAvailableInteriorColors({ variables: { inputInteriorColor: '' } });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): string[] | undefined =>
          interiorColors(x?.map(({ value }) => value) as string[])
        }
      />
    </S.SidebarFilterWrapper>
  );
};
